import React, { Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { delay } from "@formant/core/common/delay";
import { fork } from "@formant/core/common/fork";
import { TermsAndConditionsModal } from "@formant/ui-kit";

import { track } from "../analytics";
import { currentLegal } from "../legal";
import { authStore, organizationStore, userStore } from "../stores";

@observer
export class AcceptTerms extends Component {
    @observable
    private legalOptionName: string | undefined;
    @observable
    private loading: boolean = false;

    public render() {
        const { userId } = authStore;

        if (!userId) {
            return false;
        }

        const user = userStore.authenticated();

        if (!user) {
            return false;
        }

        const legal = currentLegal({ userStore, organizationStore });

        if (!legal) {
            return false;
        }

        const { date, termsDocument, privacyPolicyDocument } = legal;
        this.legalOptionName = legal.name;

        if (!termsDocument && !privacyPolicyDocument) {
            // No legal requirements, auto-accepts
            this.loading = true;
            fork(this.submit());
            return false;
        }

        // Use new UI kit modal for new terms version
        if (legal.name === "tos2.0_and_pp1.0b") {
            return (
                <TermsAndConditionsModal
                    isOpen={true}
                    onAccept={this.onSubmit}
                    onDecline={this.onLogout}
                    firstName={user.firstName}
                    hasAcceptedTerms={Boolean(user.termsAccepted)}
                    updateDate={date}
                    termsUrl={termsDocument}
                    privacyPolicyUrl={privacyPolicyDocument}
                    isLoading={this.loading}
                />
            );
        }
    }

    private onSubmit = async () => {
        await this.submit();
    };

    private async submit() {
        await delay();

        const { userId } = authStore;

        if (!this.legalOptionName || !userId) {
            return;
        }

        // For new modal, we don't need to check this.accepted since the modal handles it
        // For old modal, this.accepted is still checked in the render method

        await userStore.update(userId, {
            termsAccepted: this.legalOptionName,
        });
        track("Terms Accepted");
    }

    private onLogout = () => {
        authStore.logout();
        window.location.href = "/";
    };
}
